export const isSheet = (d: { vorlage_id: string | null; bucket_address: string | null }): boolean =>
  d.vorlage_id !== null && d.bucket_address === null

export const bySheetName = (a: string, b: string): number => a.localeCompare(b, 'de')
